import { AloDbFleet } from '@/models/alodb/AloDbFleet'
import { FilterFleet } from '@/models/filter/FilterFleet'
import { FleetUi } from '@/models/ui/FleetUi'

export interface IFleetState {
  status: string
  fleets: Array<AloDbFleet>
  //selectedFleets: Array<AloDbFleet>
  //filterResultFleets: Array<AloDbFleet>
  filterFleet: FilterFleet
  //liste des fleets ouverte en detail
  detailFleets: Array<FleetUi>
  currentDetailFleet: FleetUi
  context: any
}

const state: IFleetState = {
  status: '',
  fleets: [],
  filterFleet: new FilterFleet(),
  detailFleets: [],
  currentDetailFleet: new FleetUi(),
  context: {
    configRsync: {},
    configFtp: {},
    configLastFile: {},
  },
}

export default state
